import { TabView, TabPanel } from "primereact/tabview";
import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useParams,
} from "react-router-dom";
import { SubmissionHistoryList } from "./SubmissionHistoryList";
import { SubmissionHistoryDetail } from "./SubmissionHistoryDetail";
import { JobsInQueue } from "./JobsInQueue";

const TABS = ["activity", "queue"] as const;

const SubmissionHistoryTabs = () => {
  const { tab } = useParams<{ tab: string }>();
  const navigate = useNavigate();
  const activeIndex = Math.max(0, TABS.indexOf(tab as (typeof TABS)[number]));

  return (
    <TabView
      activeIndex={activeIndex}
      onTabChange={(e) => navigate(`../${TABS[e.index]}`, { replace: true })}
    >
      <TabPanel header="Activity Log">
        <SubmissionHistoryList />
      </TabPanel>
      <TabPanel header="Jobs in Queue">
        <JobsInQueue />
      </TabPanel>
    </TabView>
  );
};

export const SubmissionHistory = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="activity" replace />} />
      <Route path=":tab" element={<SubmissionHistoryTabs />} />
      <Route path="detail/:reportId" element={<SubmissionHistoryDetail />} />
    </Routes>
  );
};
